import { useState } from 'react';
import { XSmallIcon } from '@/icons';
import { useUser } from '@/lib/auth';
import { Button, type ButtonProps } from '@/ui_v3';
import { type GnbButtonType } from '..';
import { GnbButton } from './GnbButton';
type GnbButtonSize = NonNullable<ButtonProps['size']>;
export const LeftButtons = ({
  buttons,
  size
}: {
  buttons: GnbButtonType[];
  size?: GnbButtonSize;
}) => {
  return <>
      {buttons.map(button => <GnbButton key={button.label} button={button} size={size} />)}
      <GnbAdminButton size={size} data-sentry-element="GnbAdminButton" data-sentry-source-file="LeftButtons.tsx" />
    </>;
};
const GnbAdminButton = ({
  size = 'sm'
}: {
  size?: GnbButtonSize;
}) => {
  const {
    user
  } = useUser();
  const [isAdminButtonHidden, setIsAdminButtonHidden] = useState(false);
  const isShow = user?.admin && !isAdminButtonHidden;
  if (!isShow) return false;
  return <Button size={size} intent={'neutral'} onClick={() => {
    window.open('/admin', '_blank');
  }} data-sentry-element="Button" data-sentry-component="GnbAdminButton" data-sentry-source-file="LeftButtons.tsx">
      <>
        어드민
        <div className={'cursor-pointer'} onClick={e => {
        e.stopPropagation();
        setIsAdminButtonHidden(true);
      }}>
          <XSmallIcon size={'xs'} color={'neutral'} data-sentry-element="XSmallIcon" data-sentry-source-file="LeftButtons.tsx" />
        </div>
      </>
    </Button>;
};